// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3-UeU","header":"Messages_header__1rQU6"};